import type { StatusKind } from "~/components/editorial";

export type InstanceSyncStatus = "idle" | "syncing" | "error" | "pending";

export function instanceStatus(inst: {
  syncStatus: InstanceSyncStatus;
  lastSyncAt: string | null;
}): { kind: StatusKind; label: string } {
  switch (inst.syncStatus) {
    case "syncing":
      return { kind: "busy", label: "Syncing" };
    case "pending":
      return { kind: "wait", label: "Queued" };
    case "error":
      return { kind: "fail", label: "Failing" };
    default:
      return inst.lastSyncAt
        ? { kind: "ok", label: "Connected" }
        : { kind: "off", label: "Never synced" };
  }
}

export function formatDurationMs(ms: number | null): string {
  if (!ms) return "–";
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60000).toFixed(1)}m`;
}
